import type { ReactNode } from "react";
import type { SxProps, Theme } from "@mui/material/styles";
import { ListGridTemplate } from "@/components/list-grid/ListGridTemplate";

const AREAS = `'expand . job . subject . trigger . status . started . duration . summary . actions'`;
const COLUMNS = "32px 12px minmax(180px, 0.9fr) 12px 140px 12px 110px 12px 120px 12px 150px 12px 72px 12px minmax(200px, 1fr) 8px 32px";

interface JobListTemplateProps {
  children: ReactNode;
  onClick?: () => void;
  sx?: SxProps<Theme>;
}

/** The grid every Jobs list row and its headings are laid out on; cells place themselves by gridArea name. */
export const JobListTemplate = (props: JobListTemplateProps) => {
  const { children, onClick, sx } = props;

  return (
    <ListGridTemplate
      areas={AREAS}
      columns={COLUMNS}
      onClick={onClick}
      sx={sx}
    >
      {children}
    </ListGridTemplate>
  );
};
